import React from 'react';
import classNames from 'classnames';

import { Business as BusinessSvg } from '@eb/eds-iconography';
import { MusicNote as MusicNoteSvg } from '@eb/eds-iconography';
import { Mask as MaskSvg } from '@eb/eds-iconography';
import { Beaker as BeakerSvg } from '@eb/eds-iconography';
import { Park as ParkSvg } from '@eb/eds-iconography';
import { Cocktail as CocktailSvg } from '@eb/eds-iconography';
import { FilmCamera as FilmCameraSvg } from '@eb/eds-iconography';
import { Shoe as ShoeSvg } from '@eb/eds-iconography';
import { Heart as HeartSvg } from '@eb/eds-iconography';
import { Travel as TravelSvg } from '@eb/eds-iconography';
import { Charity as CharitySvg } from '@eb/eds-iconography';
import { Religion as ReligionSvg } from '@eb/eds-iconography';
import { RockingHorse as RockingHorseSvg } from '@eb/eds-iconography';
import { Holiday as HolidaySvg } from '@eb/eds-iconography';
import { Book as BookSvg } from '@eb/eds-iconography';
import { Megaphone as MegaphoneSvg } from '@eb/eds-iconography';
import { Fashion as FashionSvg } from '@eb/eds-iconography';
import { House as HouseSvg } from '@eb/eds-iconography';
import { Auto as AutoSvg } from '@eb/eds-iconography';
import { Game as GameSvg } from '@eb/eds-iconography';
import { Star as StarSvg } from '@eb/eds-iconography';
import { LogoInstagram as LogoInstagramSvg } from '@eb/eds-iconography';
import { LogoTwitter as LogoTwitterSvg } from '@eb/eds-iconography';
import { LogoLinkedin as LogoLinkedinSvg } from '@eb/eds-iconography';
import { LogoFacebook as LogoFacebookSvg } from '@eb/eds-iconography';
import { LogoPinterest as LogoPinterestSvg } from '@eb/eds-iconography';
import { LogoGooglePlus as LogoGooglePlusSvg } from '@eb/eds-iconography';
import { LinkChunky as LinkChunkySvg } from '@eb/eds-iconography';

import {
    BUSINESS,
    SCIENCE,
    MUSIC,
    FILM,
    PERFORMING,
    FASHION,
    HEALTH,
    SPORTS,
    TRAVEL,
    FOOD,
    CHARITY,
    POLITICS,
    COMMUNITY,
    RELIGION,
    FAMILY_EDUCATION,
    SEASONAL,
    HOME_LIFESTYLE,
    AUTO_BOAT_AIR,
    HOBBIES,
    SCHOOL,
    OTHER,
    START_DATE,
    END_DATE,
    EVENT_PAGE_PARAM,
} from '../../constants';

export * from './filters';
export * from './analytics';

export const MOBILE_BREAKPOINT = '822px';

/****************************** APP LEVEL ********************************/

/****************************** SHARED CLASSES ********************************/

export const SHARED_BUCKET_SPACING_CLASSES = classNames(
    'content-bucket',
    'eds-l-pad-vert-20',
    'eds-l-sw-pad-vert-16',
    'eds-l-sm-pad-vert-16',
    'eds-l-sn-pad-vert-16',
);

export const NON_EVENT_BUCKET_SPACING_CLASSES = classNames(
    'content-bucket',
    'eds-l-pad-top-16',
    'eds-l-sw-pad-vert-16',
    'eds-l-sm-pad-vert-16',
    'eds-l-sn-pad-vert-16',
);

export const BUCKET_WRAPPER_WITH_DECORATION_CLASSES = classNames(
    'eds-l-mar-top-5',
    'eds-l-sm-mar-top-16',
    'eds-l-sn-mar-top-16',
);

export const TAG_BACKGROUND_COLOR = 'eds-bg-color--ui-blue';
export const TAG_STYLE = 'outlined';

/****************************** TEMPLATES AND CARD TYPES ********************************/

export const ARTICLE_TEMPLATE = 'article';
export const CALENDAR_TEMPLATE = 'calendar';
export const FEATURED_TEMPLATE = 'featured';
export const CATEGORY_TEMPLATE = 'category';
export const MAP_TEMPLATE = 'map';
export const NEARBY_CITIES_TEMPLATE = 'nearby_place';
export const TRENDING_SEARCHES_TEMPLATE = 'trending_searches';
export const COLLECTION_TEMPLATE = 'collection';
export const ORGANIZER_FOLLOW_TEMPLATE = 'organizer_follow';

export const LARGE_CARD_TEMPLATE_3 = 'card_big_3';
export const LARGE_CARD_TEMPLATE_6 = 'card_big_6';
export const LIST_CARD_TEMPLATE = 'card_list';
export const CARD_TEMPLATE_4 = 'card_small_4';
export const CARD_TEMPLATE_8 = 'card_small_8';
export const CARD_BIG = 'card_big';

const THIS_WEEKEND_BUCKETS_KEY = 'this_weekend';
const POPULAR_EVENTS_BUCKET_KEY = 'popular_events';
const CURATED_EVENTS_BUCKET_KEY = 'best_of_city_events';
const MUSIC_EVENTS_BUCKET_KEY = 'music_events';

export const EDITORIAL_ARTICLES_BUCKET_KEY = 'editorial_articles';
export const FREE_EVENTS_BUCKET_KEY = 'free_events';

/****************************** URLS ********************************/

export const BASE_URL = '/d';
export const BROWSE_URL = ':location/events/';
export const SEARCH_URL = ':location/:refinementOne(/:refinementTwo)/';

export const SEARCH_RELEVANT_QUERY_PARAMS = [
    START_DATE,
    END_DATE,
    EVENT_PAGE_PARAM,
    'src',
    'bbox',
    'tags',
    'cur',
    'lang',
    'hash',
];

/****************************** CATEGORY ID MAPPING ********************************/

//Very TBD, will be replaced once official
//category graphics are put together.
export const CATEGORY_NAME_ICON_MAP = {
    [BUSINESS]: <BusinessSvg />,
    [MUSIC]: <MusicNoteSvg />,
    [PERFORMING]: <MaskSvg />,
    [SCIENCE]: <BeakerSvg />,
    [COMMUNITY]: <ParkSvg />,
    [FOOD]: <CocktailSvg />,
    [FILM]: <FilmCameraSvg />,
    [SPORTS]: <ShoeSvg />,
    [HEALTH]: <HeartSvg />,
    [TRAVEL]: <TravelSvg />,
    [CHARITY]: <CharitySvg />,
    [RELIGION]: <ReligionSvg />,
    [FAMILY_EDUCATION]: <RockingHorseSvg />,
    [SEASONAL]: <HolidaySvg />,
    [SCHOOL]: <BookSvg />,
    //Backup: 'trash'
    [POLITICS]: <MegaphoneSvg />,
    [FASHION]: <FashionSvg />,
    [HOME_LIFESTYLE]: <HouseSvg />,
    [AUTO_BOAT_AIR]: <AutoSvg />,
    [HOBBIES]: <GameSvg />,
    [OTHER]: <StarSvg />,
};

export const CATEGORY_DROPDOWN_SELECT = 'category_select';

/****************************** IMAGES ********************************/

export const DECORATIVE_IMAGE_PLACEMENT_MAP = [
    {
        selectors: [POPULAR_EVENTS_BUCKET_KEY, CURATED_EVENTS_BUCKET_KEY],
        urlSelector: 'decorationTopRightUrl',
        position: 'right',
        classes: 'decorative-image--one',
        parentClasses: 'eds-l-pad-top-6',
    },
    {
        selectors: [THIS_WEEKEND_BUCKETS_KEY],
        urlSelector: 'decorationTopLeftUrl',
        position: 'left',
        classes: 'decorative-image--two',
        parentClasses: 'eds-l-pad-top-12',
    },
    {
        selectors: [EDITORIAL_ARTICLES_BUCKET_KEY, MUSIC_EVENTS_BUCKET_KEY],
        urlSelector: 'decorationBottomRightUrl',
        position: 'right',
        classes: 'decorative-image--three',
        parentClasses: 'eds-l-pad-top-6',
    },
    {
        selectors: [FREE_EVENTS_BUCKET_KEY],
        urlSelector: 'decorationBottomLeftUrl',
        position: 'left',
        classes: 'decorative-image--four',
        parentClasses: 'eds-l-pad-top-6',
    },
];

/****************************** Artist Social Link Tye Constants ********************************/

export const SOCIAL_TYPE_ICON_MAP = {
    instagram: <LogoInstagramSvg />,
    twitter: <LogoTwitterSvg />,
    linkedin: <LogoLinkedinSvg />,
    facebook: <LogoFacebookSvg />,
    pinterest: <LogoPinterestSvg />,
    'google-plus': <LogoGooglePlusSvg />,
    web: <LinkChunkySvg />,
};

export const HEADER_HEIGHT = 72;
